import { Component, Input, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'app-typing',
  templateUrl: './typing.component.html',
  styleUrls: ['./typing.component.css'],
})
export class TypingComponent implements OnInit, OnDestroy {
  @Input() textToType = '';
  @Input() typeSpeed = 15;
  typedText = '';
  showCursor = true;
  private intervalId: any;

  ngOnInit() {
    this.typeText();
  }

  ngOnDestroy() {
    clearInterval(this.intervalId);
  }

  typeText() {
    const textArray = this.textToType.split('');

    let i = 0;
    this.intervalId = setInterval(() => {
      if (i < textArray.length) {
        this.typedText += textArray[i];
        i++;
      } else {
        clearInterval(this.intervalId);
        this.showCursor = false;
      }
    }, this.typeSpeed);
  }
}
